import React from 'react';
// import {
//   translate as t,
// } from 'admin-on-rest';

const ContactForm = () => (
  <div />
);

export default ContactForm;
